// An approved quote that never became a live order (Stephanie 2026-10-27:
// "i dont see anywhere to create the PO once the shipping is filled out").
// Client approval is meant to commit the quote in place (stage quote →
// committed), which is what shows Create purchase orders. When that step
// didn't happen, the quote sits at stage "quote" with its approval stamped.
// Such a quote may still make POs: creating them commits it first. A quote
// waiting on an upfront payment is not approved until it's paid.
export function approvedQuoteAwaitingCommit(order: {
  statusStage: string;
  statusState?: string | null;
  soApprovedAt?: string | Date | null;
  requiresUpfrontPayment?: boolean | null;
}): boolean {
  if (order.statusStage !== "quote") return false;
  if (order.requiresUpfrontPayment === true) return false;
  return order.statusState === "approved" || order.soApprovedAt != null;
}
